var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b7d112677518b977df65df0fa39e7d20cf9cb792"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["x-skamper-web@codeleap"]={id:"b7d112677518b977df65df0fa39e7d20cf9cb792"};
      